<template>
  <modal
    :open="open"
    :event-name="'openRefresh'"
    hide-scroll
    @close="closeModal"
  >
    <template slot="header">
      <h1>{{ $t('auto-logout.title') }}</h1>
    </template>
    <template slot="body">
      <p>{{ $tc('auto-logout.expiration', expiresInMinutes, { time: expiresInMinutes }) }}</p>

      <div class="btns-container">
        <x-button
          class="dark"
          :disabled="refreshing"
          @click="exit"
        >
          {{ $t('auto-logout.logout') }}
        </x-button>
        <x-button
          class="md-raised md-primary"
          :disabled="refreshing"
          @click="refreshClick"
        >
          {{ $t('auto-logout.login') }}
        </x-button>
      </div>
    </template>
  </modal>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import { unsubscribe } from '@/api'
  import modal from '@/components/modal'
  import differenceInSeconds from 'date-fns/difference_in_seconds'

  export default {
    name: 'AppRefresh',

    components: {
      'modal': modal
    },

    data () {
      return {
        authExpire: null,
        expiresInMinutes: null,
        open: false,
        refreshing: false,
        interval: null
      }
    },

    computed: {
      ...mapGetters({
        authenticated: 'auth/authenticated',
        authExpireDate: 'auth/authExpire'
      }),

      ...mapState({
        accessTokenExpirationTime: state => state.auth.accessTokenExpirationTime,
        logoutUrl: state => state.auth.logoutUrl,
        timestampLastCallApi: state => state.auth.timestampLastCallApi
      })
    },

    mounted () {
      this.start()
    },

    methods: {
      ...mapActions({
        refreshToken: 'auth/refreshToken',
        setTimestampLastCallApi: 'auth/setTimestampLastCallApi',
        logOut: 'auth/logOut'
      }),

      start () {
        const expiration = this.authExpireDate

        if (expiration) {
          this.authExpire = new Date(expiration)
          this.interval = setInterval(this.checkExpire, 5000)
        }
      },

      checkExpire () {
        const now = new Date()
        const sToExpire = differenceInSeconds(this.authExpire, now)
        const diffBetweenNowAndLastAction = (Date.now() - this.timestampLastCallApi) / 1000

        this.expiresInMinutes = Math.round((this.accessTokenExpirationTime - diffBetweenNowAndLastAction) / 60)

        if (sToExpire <= 60) this.refresh()

        if ((diffBetweenNowAndLastAction - (this.accessTokenExpirationTime - 300)) >= 0 && !this.open) {
          this.open = true
        } else if ((diffBetweenNowAndLastAction - (this.accessTokenExpirationTime - 30)) >= 0) {
          this.exit()
        }
      },

      exit () {
        this.logOut()
      },

      refresh () {
        this.refreshing = true
        this.refreshToken()
          .then(() => {
            this.reset()
            this.start()
          })
          .catch(() => {
            this.reset()
          })
      },

      refreshClick () {
        this.setTimestampLastCallApi(Date.now())
        this.refresh()
      },

      reset () {
        clearInterval(this.interval)
        this.open = false
        this.authExpire = null
        this.expiresInMinutes = null
        this.refreshing = false
        this.interval = null
      },

      closeModal () {
        this.open = false
      }
    },

    watch: {
      authenticated (val) {
        if (val) {
          this.start()
        } else {
          this.reset()
        }
      }
    },

    beforeDestroy () {
      clearInterval(this.interval)
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  h1 {
    text-align: center;
    font-weight: 600;
    font-size: 2.4rem;
  }

  .btns-container {
    margin-top: $space-big;
    text-align: center;
    display: flex;
    justify-content: space-between;
  }
</style>